(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["c-banner-imagev2"] && !Shopify.designMode) return;
  try {
    
  // No JavaScript required for this static section

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-bannner-v3"] && !Shopify.designMode) return;
  try {
    
  // Add any specific JavaScript functionality for the hero section here
  // Example: intersection observer for animations, parallax effects, etc.

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-carrusel-v2"] && !Shopify.designMode) return;
  try {
    
  function initCarruselV2() {
    const sections = document.querySelectorAll('.c-carrusel-v2');

    sections.forEach((section) => {
      const swiperEl = section.querySelector('.c-carrusel-v2__swiper');
      if (!swiperEl || swiperEl.swiper) return;

      new Swiper(swiperEl, {
        slidesPerView: 1.1,
        centeredSlides: true,
        spaceBetween: 0,
        speed: 500,
        grabCursor: true,

        navigation: {
          prevEl: section.querySelector('.c-carrusel-v2__prev'),
          nextEl: section.querySelector('.c-carrusel-v2__next'),
        },

        // FIX: attach swiper to progressbar INSIDE swiper
        pagination: {
          el: section.querySelector('.swiper-pagination'),
          type: 'progressbar',
        },

        breakpoints: {
          768: { slidesPerView: 2.5, centeredSlides: false },
          978: { slidesPerView: 3.5, centeredSlides: false },
          1200: { slidesPerView: 4, centeredSlides: false },
        },
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initCarruselV2);
  document.addEventListener('shopify:section:load', initCarruselV2);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-footer2"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const accordions = document.querySelectorAll('[data-accordion]');

    accordions.forEach((accordion) => {
      const trigger = accordion.querySelector('[data-accordion-trigger]');

      if (trigger) {
        trigger.addEventListener('click', function () {
          if (window.innerWidth < 768) {
            accordion.classList.toggle('is-open');
          }
        });
      }
    });

    window.addEventListener('resize', function () {
      if (window.innerWidth >= 768) {
        accordions.forEach((accordion) => {
          accordion.classList.remove('is-open');
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-hero-v2"] && !Shopify.designMode) return;
  try {
    
  // Add any specific JavaScript functionality for the hero section here
  // Example: intersection observer for animations, parallax effects, etc.

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    console.log('🚀 [C-Hero] Initializing...');

    const heroSections = document.querySelectorAll('.c-hero');
    
    heroSections.forEach(function(section) {
      // Auto-play video if present
      const video = section.querySelector('.c-hero__video');
      if (video) {
        video.addEventListener('loadeddata', function() {
          console.log('📹 [C-Hero] Video loaded and ready');
        });

        video.addEventListener('error', function() {
          console.error('❌ [C-Hero] Video failed to load');
        });
      }

      // Button hover effects
      const button = section.querySelector('.c-hero__button');
      if (button) {
        button.addEventListener('mouseenter', function() {
          this.style.transform = 'translateY(-2px)';
        });

        button.addEventListener('mouseleave', function() {
          this.style.transform = 'translateY(0)';
        });
      }
    });

    console.log('✅ [C-Hero] Initialization complete!');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-herov3"] && !Shopify.designMode) return;
  try {
    
  // Add any specific JavaScript functionality for the hero section here
  // Example: intersection observer for animations, parallax effects, etc.

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-main-products"] && !Shopify.designMode) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMediaContent &&
        activeMediaContent.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-main-products2"] && !Shopify.designMode) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMediaContent &&
        activeMediaContent.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-products"] && !Shopify.designMode) return;
  try {
    
  function addToCart(variantId) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    })
    .then(response => response.json())
    .then(data => {
      // Trigger cart refresh/notification
      if (window.dispatchEvent) {
        window.dispatchEvent(new CustomEvent('cart:refresh'));
      }
      alert('Product added to cart!');
    })
    .catch(error => {
      console.error('Error:', error);
      alert('Error adding product to cart');
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-reviews"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const swiperContainers = document.querySelectorAll('.c-reviews__swiper');

    swiperContainers.forEach(function (container) {
      const sectionId = container.dataset.sectionId;
      const sectionEl = document.getElementById(sectionId);
      if (!sectionEl) return;

      const prevBtn = sectionEl.querySelector('.c-reviews__nav-btn--prev');
      const nextBtn = sectionEl.querySelector('.c-reviews__nav-btn--next');
      const progressFill = sectionEl.querySelector('.c-reviews__progress-fill');
      const totalSlides = container.querySelectorAll('.swiper-slide').length;

      function getBreakpointSlidesPerView() {
        var width = window.innerWidth;
        if (width >= 1200) return 4;
        if (width >= 978) return 3;
        if (width >= 768) return 2.5;
        return 1.2;
      }

      function updateProgress(swiper) {
        if (!progressFill) return;
        var progress = swiper.progress;
        var percentage = Math.min(Math.max(progress * 100, 5), 100);
        progressFill.style.width = percentage + '%';
      }

      var swiper = new Swiper(container, {
        slidesPerView: 1.2,
        spaceBetween: 14,
        grabCursor: true,
        watchOverflow: true,
        breakpoints: {
          768: {
            slidesPerView: 2.5,
            spaceBetween: 16,
          },
          978: {
            slidesPerView: 3,
            spaceBetween: 18,
          },
          1200: {
            slidesPerView: 4,
            spaceBetween: 18,
          },
        },
        on: {
          init: function () {
            updateProgress(this);
          },
          slideChange: function () {
            updateProgress(this);
          },
          progress: function () {
            updateProgress(this);
          },
        },
      });

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          swiper.slidePrev();
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          swiper.slideNext();
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-slider-cards"] && !Shopify.designMode) return;
  try {
    
  function initSliderCardsProgressBar() {
    const sections = document.querySelectorAll('.c-why-parents-love');
    
    sections.forEach((section) => {
      const sectionId = section.id;
      const cardsContainer = section.querySelector('.c-why-parents-love__cards');
      const progressFill = section.querySelector('.c-why-parents-love__progress-fill');

      if (!cardsContainer || !progressFill) {
        console.log('Cards container or progress fill not found for section:', sectionId);
        return;
      }

      function updateProgress() {
        const scrollLeft = cardsContainer.scrollLeft;
        const scrollWidth = cardsContainer.scrollWidth - cardsContainer.clientWidth;
        const scrollPercentage = scrollWidth > 0 ? 10 + (scrollLeft / scrollWidth) * 90 : 10;
        progressFill.style.width = scrollPercentage + '%';
      }

      // Remove existing listeners to avoid duplicates
      cardsContainer.removeEventListener('scroll', updateProgress);
      window.removeEventListener('resize', updateProgress);

      // Add listeners
      cardsContainer.addEventListener('scroll', updateProgress);
      window.addEventListener('resize', updateProgress);
      
      // Initialize progress on load
      setTimeout(updateProgress, 100);
    });
  }

  // Execute when DOM is ready
  document.addEventListener('DOMContentLoaded', initSliderCardsProgressBar);
  document.addEventListener('shopify:section:load', initSliderCardsProgressBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-timmer"] && !Shopify.designMode) return;
  try {
    
  class CountdownTimer {
    constructor() {
      this.countdowns = document.querySelectorAll('[data-countdown]');
      this.init();
    }

    init() {
      this.countdowns.forEach((countdown) => {
        const endDate = countdown.getAttribute('data-end-date');
        if (endDate) {
          this.startCountdown(countdown, new Date(endDate).getTime());
        }
      });
    }

    startCountdown(element, endTime) {
      const daysEl = element.querySelector('[data-days]');
      const hoursEl = element.querySelector('[data-hours]');
      const minutesEl = element.querySelector('[data-minutes]');
      const secondsEl = element.querySelector('[data-seconds]');

      const updateTimer = () => {
        const now = new Date().getTime();
        const distance = endTime - now;

        if (distance < 0) {
          daysEl.textContent = '00';
          hoursEl.textContent = '00';
          minutesEl.textContent = '00';
          secondsEl.textContent = '00';
          return;
        }

        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        daysEl.textContent = days.toString().padStart(2, '0');
        hoursEl.textContent = hours.toString().padStart(2, '0');
        minutesEl.textContent = minutes.toString().padStart(2, '0');
        secondsEl.textContent = seconds.toString().padStart(2, '0');
      };

      updateTimer();
      setInterval(updateTimer, 1000);
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    new CountdownTimer();
  });

  // Also initialize if the section is loaded via AJAX (Shopify editor)
  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', () => {
      new CountdownTimer();
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lw-prelaunch-product"] && !Shopify.designMode) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMediaContent &&
        activeMediaContent.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
